import styled, { css } from 'styled-components';

import { IPickerAspectUiPattern } from '@rbi-ctg/menu';
import VisuallyHidden from 'components/visually-hidden';
import { isUiPatternRadio } from 'state/menu/types';

import { ISelectionIndicatorProps } from '.';

export const HiddenInput = VisuallyHidden.withComponent('input');

interface IIndicatorContainer extends IPickerAspectUiPattern {
  checked: boolean;
  hasBackground?: boolean;
}

export const IndicatorContainer = styled.div<IIndicatorContainer>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  input:focus + &::after {
    content: '';
    position: absolute;
    top: 3px;
    bottom: 3px;
    left: 3px;
    right: 3px;
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
  }

  ${p =>
    isUiPatternRadio(p) &&
    css`
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      min-height: auto;
      min-width: auto;
      border: none;
      border-radius: 0;
      background-color: 0;

      input:focus + &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: none;
        border-radius: 0;
        outline-color: -webkit-focus-ring-color;
        outline-style: auto;
      }
    `}
`;

const setBackgroundColor = (p: ISelectionIndicatorProps) => {
  if (p.defaultValue) {
    return Styles.color.grey.one;
  }
  if (p.checked) {
    return Styles.color.primary;
  }
  return Styles.color.white;
};

const setBorder = (p: ISelectionIndicatorProps) => {
  const border = '1px solid ';
  if (p.disabled) {
    return border + Styles.color.grey.four;
  }
  return p.checked ? 'none' : border + Styles.color.grey.three;
};
const Indicator = styled.span<ISelectionIndicatorProps & IPickerAspectUiPattern>`
  background-color: ${p => setBackgroundColor(p)};
  border: ${p => setBorder(p)};
  position: absolute;
  border-radius: ${p => (p.type === 'checkbox' ? '5px' : '50%')};
  top: 50%;
  right: 0.1rem;
  height: ${p => p.size}rem;
  width: ${p => p.size}rem;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${p => (p.hideInput ? '0' : 'inherit')}}
  ${p =>
    p.hasBackground &&
    css`
      position: relative;
    `}
  ${p =>
    p.type === 'radio'
      ? css`
          &:after {
            border: ${Math.round(p.size * 2.6)}px solid ${Styles.color.white};
            content: '';
            position: absolute;
            width: ${Math.round(p.size * 13)}px;
            height: ${Math.round(p.size * 13)}px;
            border-radius: 50%;
          }
        `
      : css`
          &:after {
            position: absolute;
            display: ${p.checked ? 'block' : 'none'};
            top: 50%;
            left: 50%;
            height: ${p.size * 0.42 * 1.2}rem;
            width: ${p.size * 0.22 * 1.2}rem;
            border: solid ${Styles.color.white};
            border-width: 0 2px 2px 0;
            border-color: ${p.checked ? Styles.color.black : ''};
            content: '';
            transform: translate(-50%, -50%) rotate(45deg);

            ${p.hasBackground &&
            css`
              border-color: ${Styles.color.white};
            `}
          }
        `};
`;

export default Indicator;
